import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from '../base.service';
var OrganisationAssessmentAnswerService = /** @class */ (function (_super) {
    tslib_1.__extends(OrganisationAssessmentAnswerService, _super);
    function OrganisationAssessmentAnswerService(http) {
        var _this = _super.call(this, 'organisation-assessment-answer', http) || this;
        _this.http = http;
        return _this;
    }
    OrganisationAssessmentAnswerService.prototype.ngOnInit = function () {
    };
    return OrganisationAssessmentAnswerService;
}(BaseService));
export { OrganisationAssessmentAnswerService };
